<script lang="ts" setup>
import { useTranslate } from '@tolgee/vue'

import { usePublicData } from '@/stores/PublicData'

import EditorSettings from '@/components/editor/EditorSettings.vue'
import EditorSettingsHeroSocial from '@/components/editor/EditorSettingsHeroSocial.vue'
import EditorSettingsHeroContent from '@/components/editor/EditorSettingsHeroContent.vue'
import EditorSettingsHeroLogo from '@/components/editor/EditorSettingsHeroLogo.vue'
import EditorSettingsHeroStyle from '@/components/editor/EditorSettingsHeroStyle.vue'
import EditorSettingsHeroImage from '@/components/editor/EditorSettingsHeroImage.vue'
import { LANGUAGES, type LanguageType } from '@/api/interfaces'

const { t } = useTranslate('local')
const store = usePublicData()

const defaultItems = [
  {
    title: t.value('EditorHeroSettings.content.title'),
    description: t.value('EditorHeroSettings.content.description'),
    component: EditorSettingsHeroContent,
  },
]

const items = {
  ...LANGUAGES.reduce(
    (acc, lang) => {
      acc[lang] = [...defaultItems]
      return acc
    },
    {} as Record<LanguageType, typeof defaultItems>,
  ),
  en: [
    {
      title: t.value('EditorHeroSettings.style.title'),
      description: t.value('EditorHeroSettings.style.description'),
      component: EditorSettingsHeroStyle,
    },
    {
      title: t.value('EditorHeroSettings.image.title'),
      component: EditorSettingsHeroImage,
    },
    {
      title: t.value('EditorHeroSettings.logo.title'),
      description: t.value('EditorHeroSettings.logo.description'),
      component: EditorSettingsHeroLogo,
    },
    {
      title: t.value('EditorHeroSettings.content.title'),
      description: t.value('EditorHeroSettings.content.description'),
      component: EditorSettingsHeroContent,
    },
    {
      title: t.value('EditorHeroSettings.social.title'),
      description: t.value('EditorHeroSettings.social.description'),
      component: EditorSettingsHeroSocial,
    },
  ],
}
</script>

<template>
  <EditorSettings :items="items[store.lang]" :title="t('EditorHeroSettings.title')" />
</template>

<style lang="scss" scoped></style>
